'use client';

import { createContext, createElement, useContext, type ReactNode } from 'react';
import { useBoolVariation } from '@launchdarkly/react-sdk';

export const JIRA_INTEGRATION_FLAG_KEY = 'jira-integration';

export type IntegrationsFlagState = {
  enabled: boolean;
  isLoading: boolean;
  error: Error | null;
};

export const DEFAULT_INTEGRATIONS_FLAG_STATE: IntegrationsFlagState = {
  enabled: false,
  isLoading: false,
  error: null,
};

const IntegrationsFlagContext = createContext<IntegrationsFlagState>(
  DEFAULT_INTEGRATIONS_FLAG_STATE,
);

export function IntegrationsFlagProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: IntegrationsFlagState;
}) {
  return createElement(IntegrationsFlagContext.Provider, { value }, children);
}

export function useLaunchDarklyIntegrationsFlag(): IntegrationsFlagState {
  const enabled = useBoolVariation(JIRA_INTEGRATION_FLAG_KEY, false);
  return { enabled, isLoading: false, error: null };
}

export function useIntegrationsEnabled(): IntegrationsFlagState {
  return useContext(IntegrationsFlagContext);
}
